<template>
	<div class="open_face_register">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">开启人脸注册</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			开启本地人脸注册流程。
		</p>
		<h3 class="doc_main_h3">函数</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">+ (NSString *)skFaceStartRegPerson:(int)regModel
                        personName:(NSString *)personName
                         personSex:(int)personSex
                         birthYear:(int)birthYear
                        birthMonth:(int)birthMonth
                          birthDay:(int)birthDay
                       detailsInfo:(NSString *)detailsInfo
                          groupsID:(NSString *)groupsID
                            startX:(int)startX
                            startY:(int)startY
                             width:(int)width
                            height:(int)height
                  registerCallback:(EventRegisterCallBack)registerCallback
          registerProgressCallback:(EnventRegisterProgressCallBack)registerProgressCallback;</code></pre>
        <h3 class="doc_main_h3">注册人员属性参数</h3>
        <p class="doc_main_p">
        	（1）regModel：注册模式：0：快速注册（默认值）、1：标准注册、2：精准注册，其他值默认为 0
        </p>
        <p class="doc_main_p">
        	（2）personName：注册人员姓名(最长20个字符，仅支持汉字、字母、数字、下划线)
        </p>
        <p class="doc_main_p">
        	（3）personSex：注册人员性别（1：女，2：男，0：SDK识别出的性别）
        </p>
        <p class="doc_main_p">
        	（4）birthYear：注册人员生日-年份（传入1900，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（5）birthMonth：注册人员生日-月份（传入01，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（6）birthDay：注册人员生日-几日（传入01，为默认值，SDK识别出的年龄）
        </p>
        <p class="doc_main_p">
        	（7）detailsInfo：细节信息（其他备注信息，可为空）
        </p>
        <p class="doc_main_p">
        	（8）groupsID：注册人员组ID（人员组id用“,”隔开，@“”为默认值，例如：”2001，2002”，表示当前人员注册到人员组id为2001.2002的分组下，默认分组为当前终端所关联全部分组，没有关联人员组会创建一个新分组）
        </p>
        <h3 class="doc_main_h3">注册区域参数</h3>
        <p class="doc_main_p">
        	（1）startX：有效注册区域的起点坐标x值（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（2）startY：有效注册区域的起点坐标y值（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（3）width：从(StartX, StartY)点向右Width为有效注册区域（请注意转换为分辨率对应值）
        </p>
        <p class="doc_main_p">
        	（4）height：从(StartX, StartY)点向下Height为有效注册区域（请注意转换为分辨率对应值）
        </p>
		<h3 class="doc_main_h3">回调函数参数</h3>
		<p class="doc_main_p">
        	（1）registerCallback：注册状态回调：registerCallback(int code, NSString * msg, NSSring * personinfo); code 状态码；msg 状态消息； personInfo Person信息
        </p>
        <p class="doc_main_p">
        	（2）registerProgressCallback：注册进度回调：注册进度信息registerProgressCallback (NSString *registerProgressInfo); registerProgressInfo：格式为37个int值（0/1）组成的数组json串 
        </p>
        <h3 class="doc_main_h3">返回值</h3>
        <p class="doc_main_p">
        	字符串类型，人员属性参数不正确时会返回错误信息，与注册状态回调函数返回信息一致。
        </p>
        <h3 class="doc_main_h3">回调值</h3>
        <h4 class="doc_main_h4">注册状态回调结果列表</h4>
        <register-state-callback-table></register-state-callback-table>
        <h4 class="doc_main_h4">注册进度回调结果列表</h4>
        <register-progress-callback-table></register-progress-callback-table>
        <h3 class="doc_main_h3">示例代码</h3>
        <pre class="doc_main_pre"><code class="doc_main_code">//开始人脸注册
NSString * errorStr = [SKFaceManagerInterface skFaceStartRegPerson:1 personName:@"小明" 
personSex:0 birthYear:1900 birthMonth:01 birthDay:01 detailsInfo:@“” groupsID:@“” startX:0 
startY:0 width:1280 height:720 registerCallback:^(int code, NSString *msg, NSString *personInfo) {
      //这里处理注册状态
      if (code == 5001) {
          //注册成功，成功后需要调用停止人脸注册接口
      }else{
          //注册失败
      }
  } registerProgressCallback:^(NSString *registerProgressInfo) {
     //这里处理注册进度
     //37个int值的数组json串，需解析出来 progressInfo = @[@"0", @"0", @"0", ...... , @"1", @"1", @"1"];
     NSArray * progressInfo = [Utiles stringToJSONArray:registerProgressInfo];
}]</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import RegisterStateCallbackTable from '../../../../components/registerStateCallbackTable'
	import RegisterProgressCallbackTable from '../../../../components/registerProgressCallbackTable'
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,//引入顶部面包屑导航
			'register-state-callback-table':RegisterStateCallbackTable,//引入注册状态列表
			'register-progress-callback-table':RegisterProgressCallbackTable,//引入注册进度列表
		},
		data(){
			return{
				isPathData:['人脸识别','SKFace-iOS','本地接口','开启人脸注册'],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.open_face_register{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/skfaceios/localface/openFaceRegister.vue